import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import Immutable from 'immutable';
import debounce from 'lodash/debounce';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { fillDetails } from '../../models/profile';
import Post, { fillDetails as fillPostDetails } from '../../models/post';
import * as actions from '../../actions';
import { PROFILE_IMAGE } from '../../constants/ModalTypes';
import Gnb from '../../components/Gnb';
import NotFoundPage from '../NotFoundPage';

import PostBox from '../../components/PostBox';
import PostCountBar from '../../components/PostCountBar';
import ProfileImage from '../../components/ProfileImage';

import numberFormat from '../../utils/numberFormat';
import getImageUrl from '../../utils/getImageUrl';
import AgeAuthAlertModal from '../../components/AgeAuthAlertModal';
import { getVerificationBadgeSpan } from '../../utils/profileUtils';
import tiaraClickSender from '../../utils/tiaraClickSender';

const actionButtons = {
  'participate': { class: 'party', label: '참여하기' },
  'tel': { class: 'call', label: '전화하기' },
  'coupon': { class: 'coupon', label: '쿠폰받기' },
  'video': { class: 'video', label: '동영상보기' },
  'more': { class: 'examine', label: '더 알아보기' },
  'donate': { class: 'gift', label: '기부하기' },
  'inquiry': { class: 'detail', label: '문의하기' },
  'web': { class: 'web', label: '웹사이트' },
  'game': { class: 'game', label: '게임하기' },
  'openchat': { class: 'chat', label: '오픈채팅' },
  'app': { class: 'app', label: '앱 사용하기' },
  'buy': { class: 'buy', label: '구매하기' },
  'reserve': { class: 'reserve', label: '예약하기' },
  'subscribe': { class: 'join', label: '가입하기' },
  'order': { class: 'order', label: '주문하기' },
  'talkorder': {class: 'talkorder', label: '톡 주문하기'},
  'music': { class: 'music', label: '음악듣기' },
  'store': { class: 'store', label: '스토어' },
  'talkstore': { class: 'talkstore', label: '톡 스토어' },
  'cafe': { class: 'cafe', label: '공식카페' },
  'hospital': { class: 'hospital', label: '병원가기' },
  'membership': { class: 'membership', label: '멤버십' },
};

export class ProfilePage extends Component {
  constructor(props) {
    super(props);
    this.handleScroll = debounce(this.handleScroll, 100).bind(this);
    this.clickIdentityNumber = this.clickIdentityNumber.bind(this);
    this.clickProfileImage = this.clickProfileImage.bind(this);
    this.clickBackgroundImage = this.clickBackgroundImage.bind(this);
    this.clickActionButton = this.clickActionButton.bind(this);
    this.changeTab = this.changeTab.bind(this);
    this.renderPost = this.renderPost.bind(this);
    this.renderFeed = this.renderFeed.bind(this);
    this.renderInfo = this.renderInfo.bind(this);
    this.renderBizInfo = this.renderBizInfo.bind(this);
    this.renderFooter = this.renderFooter.bind(this);
    this.fetchPosts = this.fetchPosts.bind(this);
    this.state = {
      tab: 'feed'
    };
  }

  componentDidMount() {
    // 새로고침 된 경우 최상단으로 스크롤 됨.
    try {
      if (window.performance.navigation.type === 1) {
        setTimeout(function () {
          window.scrollTo(0, 0);
        }, 500);
      }
    } catch(ignore) {
      // window.performance.navigation 가 없을 수 있음
    }

    if (typeof window !== 'undefined') {
      window.addEventListener("scroll", this.handleScroll);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll() {
    const { hasNext } = this.props;

    const scrollNode = document.scrollingElement ? document.scrollingElement : document.documentElement;
    const scrollHeight = scrollNode.scrollHeight;
    const scrollTop = scrollNode.scrollTop;
    const offsetHeight = scrollNode.offsetHeight;

    if (hasNext && (scrollHeight - (2 * offsetHeight) < scrollTop)) {
      this.fetchPosts();
    }
  }

  clickIdentityNumber() {
    const { profile: { businessPartnerInfo } } = this.props;
    const identityNumber = businessPartnerInfo.get('identityNumber').split('-').join('');
    window.open(`http://www.ftc.go.kr/info/bizinfo/communicationViewPopup.jsp?wrkr_no=${identityNumber}`, '_blank', "width=750, height=700;");
  }

  clickProfileImage() {
    const { showModal, profile: { profileImage } } = this.props;
    showModal(PROFILE_IMAGE, { profileImage });
  }

  clickBackgroundImage() {
    const { showModal, profile: { coverImage } } = this.props;
    if (coverImage && coverImage.get('largeUrl') && coverImage.get('largeUrl') !== '') {
      showModal(PROFILE_IMAGE, { coverImage });
    }
  }

  clickActionButton() {
    const { profile: { call2action }, device } = this.props;
    const isPC = device.get('os').get('name') !== 'Android' && device.get('os').get('name') !== 'iOS';

    if (call2action.get('type') === 'tel') {
      if (isPC) {
        alert(`전화번호는 ${call2action.get('tel')} 입니다.`);
      } else {
        window.open(`tel:${call2action.get('tel')}`, '_self');
      }
    } else {
      if (isPC ||
        (!call2action.get('urls').get('androidExecute') && device.get('os').get('name') === 'Android') ||
        (!call2action.get('urls').get('iosExecute') && device.get('os').get('name') === 'iOS')) {
        window.open(call2action.get('urls').get('web'), '_blank');
      } else {
        const executeUrl = device.get('os').get('name') === 'Android' ? call2action.getIn(['urls', 'androidExecute']) : call2action.getIn(['urls', 'iosExecute']);
        const installUrl = device.get('os').get('name') === 'Android' ? call2action.getIn(['urls', 'androidInstall']) : call2action.getIn(['urls', 'iosInstall']);

        const splited = executeUrl.split('://');
        const intentUrl = `intent://${splited[1]}#Intent;scheme=${splited[0]};end`;

        const clickedAt = +new Date;
        setTimeout(() => {
          if (+new Date - clickedAt < 2000) {
            location.href = installUrl;
          }
        }, 1500);
        location.href = device.get('os').get('name') === 'Android' ? intentUrl : executeUrl;
      }
    }
  }

  changeTab(name) {
    this.setState({
      tab: name
    });
  }

  fetchPosts() {
    const { fetchPosts, profile, posts } = this.props;
    fetchPosts(profile.profileId, { since: posts.last().sort })
  }

  renderPost(post, idx) {
    const { showModal, device } = this.props;
    return (
      <div className="wrap_post" key={idx}>
        <PostBox type="feed" post={post} device={device} />
        <div className="post_cmt">
          <PostCountBar
            profile={post.author}
            post={post}
            showModal={showModal}
            device={device}
          />
        </div>
      </div>
    );
  }

  renderFeed() {
    const { posts, hasNext, profile } = this.props;

    if (posts.isEmpty()) {
      const spamLevel = profile.spamLevel;
      let desc = '아직 작성된 소식이 없습니다.';
      if (spamLevel === 5) {
        desc = '운영정책에 의해 제재된 프로필로 모든 포스트가 블라인드되었습니다.';
      } else if (spamLevel === 6) {
        desc = '권리침해신고에 의해 임시조치된 프로필로 모든 포스트가 블라인드되었습니다.';
      }
      return (
        <div className="view_post">
          <p className="desc_none">
            <span className="ico_plus" />
            {desc}
          </p>
        </div>
      );
    }

    return (
      <div>
        {posts.map(this.renderPost)}
        {hasNext ? (
          <div className="post_load" style={{ backgroundColor: '#efefef' }}>
            <span className="ico_load">로딩중입니다.</span>
          </div>
        ) : (
          <div className="post_copyright" style={{ backgroundColor: '#efefef' }}>
            <span className="screen_out">Copyright</span><span className="ico_plus">카카오톡 채널</span>
          </div>
        )}
      </div>
    );
  }

  renderInfo() {
    const { profile } = this.props;

    return (
      <div>
      <div className="wrap_profile">
        <ul className="list_info">
          {profile.category && (
            <li>
              <em className="tit_info">카테고리</em>
              <p className="desc_info">
                {profile.category.get('categoryFullName') || profile.category.get('name')}
              </p>
            </li>
          )}
          {profile.siteUrl && (
            <li>
              <a href={profile.siteUrl} className="link_info" target="_blank">
                <em className="tit_info">홈페이지</em>
                <p className="desc_info">
                  {profile.siteUrl}
                  <span className="ico_plus">바로가기</span>
                </p>
              </a>
            </li>
          )}
          {profile.phone && (
            <li>
              <a href={`tel:${profile.phone}`} className="link_info">
                <em className="tit_info">전화번호</em>
                <p className="desc_info">
                  {profile.phone}
                  <span className="ico_plus">전화걸기</span>
                </p>
              </a>
            </li>
          )}
          {profile.email && (
            <li>
              <a href={`mailto:${profile.email}`} className="link_info">
                <em className="tit_info">이메일</em>
                <p className="desc_info">
                  {profile.email}
                  <span className="ico_plus">이메일보내기</span>
                </p>
              </a>
            </li>
          )}
          {profile.address && !profile.address.isEmpty() && (
            <li>
              <em className="tit_info">주소</em>
              <p className="desc_info">
                {profile.address.get('address')}
                {!!profile.address.get('detail') ? ` ${profile.address.get('detail')}` : ''}
              </p>
            </li>
          )}
        </ul>
        {profile.businessPartnerInfo.isEmpty() && this.renderFooter()}
      </div>
      {!profile.businessPartnerInfo.isEmpty() && this.renderBizInfo()}
    </div>);
  }

  renderBizInfo() {
    const { profile, profile: { businessPartnerInfo } } = this.props;
    return (
      <div className="wrap_profile">
        <ul className="list_info">
          <li>
            <em className="tit_info">사업자 등록정보</em>
          </li>
          {businessPartnerInfo.get('name') && (
              <li>
                <em className="tit_info">업체명</em>
                <p className="desc_info">
                  {businessPartnerInfo.get('name')}
                </p>
              </li>
            )
          }
          {businessPartnerInfo.get('identityNumber') && (
              <li>
                <a href="#none" className="link_info" onClick={this.clickIdentityNumber}>
                  <em className="tit_info">사업자등록번호</em>
                  <p className="desc_info">
                    {businessPartnerInfo.get('identityNumber')}
                    <span className="ico_plus">공정위 페이지로 이동</span>
                  </p>
                </a>
              </li>
            )
          }
          {businessPartnerInfo.get('representativeName') && (
              <li>
                <em className="tit_info">대표자명</em>
                <p className="desc_info">
                  {businessPartnerInfo.get('representativeName')}
                </p>
              </li>
            )
          }
          {businessPartnerInfo.get('typeItem') && (
              <li>
                <em className="tit_info">업태</em>
                <p className="desc_info">
                  {businessPartnerInfo.get('typeItem')}
                </p>
              </li>
            )
          }
          {businessPartnerInfo.get('businessItem') && (
              <li>
                <em className="tit_info">종목</em>
                <p className="desc_info">
                  {businessPartnerInfo.get('businessItem')}
                </p>
              </li>
            )
          }
          {businessPartnerInfo.get('address') && (
            <li>
              <em className="tit_info">주소</em>
              <p className="desc_info">
                {businessPartnerInfo.get('address')}
              </p>
            </li>
          )}
          {businessPartnerInfo.get('mailOrderNumber') && (
            <li>
              <em className="tit_info">통신판매신고번호</em>
              <p className="desc_info">
                {businessPartnerInfo.get('mailOrderNumber')}
              </p>
            </li>
          )
          }
        </ul>
        {this.renderFooter()}
      </div>
    );
  }

  renderFooter() {
    return (
      <p className="txt_info">
        이 정보는 카카오톡 채널 운영자가 등록한 정보입니다<span className="ico_plus" />
      </p>
    );
  }

  renderCall2Action() {
    const { profile, connections } = this.props;
    const { call2action } = profile;
    const hasCall2action = !call2action.isEmpty();
    const connectedProfiles = hasCall2action ? call2action.get('connected', false) : false;
    const call2ActionType = call2action.get('type');
    let actionType = `${connectedProfiles?'talk':''}${call2ActionType}`;
    if (actionType === 'talkstore') {
      const isValidStoreConnection = connections.filter(connection => connection.get('serviceType') === 'store').size !== 0
        && call2action.get('urls', Immutable.Map()).get('web', '').indexOf('store.kakao.com') !== -1;
      if (!isValidStoreConnection) {
        actionType = 'store';
      }
    }
    const call2actionButton = hasCall2action ? actionButtons[`${actionType}`] : null;

    return (
      hasCall2action && call2actionButton && (
        <button type="button" className={`btn_util btn_${call2actionButton.class} call2action`} onClick={this.clickActionButton}>
          <span className="ico_plus ico_button" />
          <span className="inner_txt">{ call2actionButton.label }</span> 
        </button>
      )
    );
  }

  render() {
    const { device, profile } = this.props;
    if (!profile) {
      return (
        <div>
          <Gnb device={device} />
          <NotFoundPage />;
        </div>
      )
    }
    const { coverImage, profileImage, statusMessage, friendCount, isChatBot } = profile;
    return (
      <div>
        <Gnb profile={profile} device={device} />
        <div id="kakaoContent" className="cont_plus" role="main">
          <div id="mArticle">
            <h2 id="kakaoBody" className="screen_out">프로필 본문영역</h2>

            <div>
              <strong className="screen_out">메인 프로필</strong>
              <div className="view_profile">{/* 메인 프로필 */}
                <div className="bg_profile"
                  style={coverImage.get('largeUrl', '') ? { backgroundImage: `url(${getImageUrl(coverImage.get('largeUrl', ''))})` } : null}
                >
                  <span style={{ position: 'absolute', width: '100%', height: '100%', zIndex: 50 }} onClick={this.clickBackgroundImage} />
                  <div className="wrap_thumb">
                    <a href="#none" className="link_thumb" onClick={this.clickProfileImage}>
                      <ProfileImage image={profileImage} sizeType="small" />
                      <span className="screen_out">프로필 사진 보기</span>
                    </a>
                  </div>
                </div>
                <div className="desc_info">
                  <strong className="tit_info">
                    {profile.name}
                    {getVerificationBadgeSpan(profile.verificationType)}
                  </strong>
                  {
                    friendCount > 0 &&
                      <em className="txt_count">친구 <span className="num_count">{numberFormat(friendCount)}</span>명</em>
                  }
                  {
                    statusMessage && statusMessage !== '' &&
                      <p className="txt_info">
                        { statusMessage }
                      </p>
                  }
                  <div className="profile_util">
                    <a href={`/${profile.profileId}/chat`} target="_blank" className="chatting" data-tiara-layer="chatting">
                      <button type="button" className={classnames('btn_util', { btn_chatting: !isChatBot, btn_chatbot: isChatBot})}>
                        <span className="ico_plus ico_button" />
                        <span className="inner_txt">채팅하기</span>
                      </button>
                    </a>

                    <a href={`/${profile.profileId}/friend`} target="_blank" className="add_friend" data-tiara-layer="add_friend">
                      <button type="button" className="btn_util btn_add">
                        <span className="ico_plus ico_button" />
                        <span className="inner_txt">채널 추가</span>
                      </button>
                    </a>

                    {this.renderCall2Action()}

                    </div>
                </div>
              </div>{/* // 메인 프로필 */}
            </div>

            <strong className="screen_out">포스트 메뉴</strong>

            <ul className="list_menu">
              <li className={this.state.tab === 'feed' ? 'on' : ''}>
                <a href="#none" onClick={() => this.changeTab('feed')} className="link_menu">소식</a>
              </li>
              <li className={this.state.tab === 'info' ? 'on' : ''}>
                <a href="#none" onClick={() => this.changeTab('info')} className="link_menu">정보</a>
              </li>
            </ul>

            { this.state.tab === 'feed' ? this.renderFeed() : this.renderInfo() }

          </div>
        </div>
        <AgeAuthAlertModal
            renderCancelBtn={false}
            {...this.props}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, { match: { params: { encodedProfileId } } } ) => {
  const { entities, profile, device } = state;
  const profiles = entities.get('profiles', Immutable.Map());
  const selectedProfile = fillDetails(profiles.get(`${encodedProfileId}`), entities);
  const validType = selectedProfile ? selectedProfile.authInfo.get('validType') : '';
  const posts = profile.get('posts', Immutable.Map());
  const postItems = posts.get('items', Immutable.List())
    .map(post => fillPostDetails(entities.getIn(['posts', `${post}`], new Post()), entities))
    .map(post => post.set('author', selectedProfile));
  const connections = profile.get('connections', Immutable.List())
    .filter(connection => connection.get('profileId') == selectedProfile && selectedProfile.get('id'));

  return { profile: selectedProfile, posts: postItems,  hasNext: posts.get('hasNext'), device, connections, validType };
};

export default connect(
  mapStateToProps,
  (dispatch) => bindActionCreators({
    showModal: actions.showModal,
    fetchPosts: actions.fetchPosts
  }, dispatch)
)(tiaraClickSender(ProfilePage));



// WEBPACK FOOTER //
// ./src/containers/ProfilePage/index.js